import { getOr } from 'lodash/fp';

export const getOrNull = getOr(null);
